import dayjs from 'dayjs'

// 2026-09-22：分店会员按实际到期时间提前一个自然月提醒，续费后重新计算，不沿用过期文案。
export interface BranchMembershipInfo {
  id?: number | string
  levelExpired?: number | string | null
  displayLevelText?: string | null
  vipRoleId?: number | string | null
  executeLevel?: number | string | null
}

// 2026-09-22：多管理员绑定时优先匹配当前账号；老账号仅在关联唯一时兼容，避免随机取到其他会员。
export function selectBranchMembership(rows: BranchMembershipInfo[], customerId: unknown): BranchMembershipInfo | undefined {
  if (Number(customerId) > 0) return rows.find(row => Number(row.id) === Number(customerId))
  return rows.length === 1 ? rows[0] : undefined
}

export function branchMembershipReminder(member: BranchMembershipInfo | undefined, now: number): string {
  // 人工取消VIP会保留历史期限；兼容旧会员名称，但不把明确取消的普通用户提示为即将过期。
  const name = member?.displayLevelText?.trim() || '会员'
  if (Number(member?.vipRoleId || 0) <= 0 && Number(member?.executeLevel || 0) <= 0
    && /普通用户|普通会员/.test(name)) return ''
  const timestamp = Number(member?.levelExpired)
  if (!Number.isFinite(timestamp) || timestamp <= 0 || !Number.isFinite(now)) return ''
  const expiry = dayjs(timestamp)
  if (!expiry.isValid()) return ''
  if (timestamp <= now) return '您的会员已过期，请及时续费，续费后功能自动恢复'
  if (now < expiry.subtract(1, 'month').valueOf()) return ''
  return `您的${name}在${expiry.format('YYYY年MM月DD日')}过期，请及时续费`
}
